<template>
  <div class="fx fx-s-center justify-between">
    <div class="title fx-s-center">
      <div class="default-bar"></div>
      <slot />
    </div>
    <div class="right-btn">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'myTitle',
  props: {
  }
}
</script>

<style lang='scss' scoped>
.title {
  font-size: 16px;
  font-weight: 600;
  .default-bar {
    width: 3px;
    height: 14px;
    background: #5088ff;
    display: block;
    margin-right: 8px;
  }

  // span {
  //   font-family: MicrosoftYaHei-Bold;
  //   font-size: 18px;
  //   font-weight: normal;
  //   font-stretch: normal;
  //   letter-spacing: 0px;
  //   color: #f9fafc;
  // }
}
.right-btn {
  cursor: pointer;
  color: #5088ff;
  font-size: 12px;
}
</style>
